module.exports = __webpack_public_path__ + "static/media/my_orders_french.ed378a1a.jpg";